import {
  howItWorksImg1,
  howItWorksImg2,
  howItWorksImg3,
} from '../../../../../src/images';

export const showcaseProducts = {
  Product1: {
    title: '01 Begin Your Journey',
    description:
      'Start with 1 packet taken three times daily. Then reduce to 2 or even 1 packet daily as pain reduction is achieved. Then continue taking Relief Factor daily to stay out of pain.',
    image: howItWorksImg1,
  },
  Product2: {
    title: '02 Your Transformation',
    description:
      'In just a few weeks, many of our customers reduce or even eliminate their daily pain. In extreme circumstances, some people take a few months to achieve their pain relief.',
    image: howItWorksImg2,
  },

  Product3: {
    title: '03 Reclaim Your Life',
    description:
      'Remember what it was like to live your life without pain, doing what you want to do without concerns about pain. Rekindle a lost passion, improve relationships strained by pain.',
    image: howItWorksImg3,
  },
};
